import { render, staticRenderFns } from "./storeGoodsList.vue?vue&type=template&id=1beda104&scoped=true&"
import script from "./storeGoodsList.vue?vue&type=script&lang=js&"
export * from "./storeGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./storeGoodsList.vue?vue&type=style&index=0&id=1beda104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beda104",
  null
  
)

component.options.__file = "storeGoodsList.vue"
export default component.exports